import { baseWebAuthConfig } from '@sprint-backoffice/app/core/auth/auth-config';
import { AuthConfig } from 'angular-oauth2-oidc';

const webAuthConfig: AuthConfig = {
  ...baseWebAuthConfig,
  issuer: 'https://auth.sprintapp.team/realms/sprint-backoffice-app',
  userinfoEndpoint:
    'https://auth.sprintapp.team/realms/sprint-backoffice-app/protocol/openid-connect/userinfo',
  tokenEndpoint:
    'https://auth.sprintapp.team/realms/sprint-backoffice-app/protocol/openid-connect/token',
  revocationEndpoint:
    'https://auth.sprintapp.team/realms/sprint-backoffice-app/protocol/openid-connect/revoke',
  logoutUrl:
    'https://auth.sprintapp.team/realms/sprint-backoffice-app/protocol/openid-connect/logout',
  strictDiscoveryDocumentValidation: true,
  redirectUri: window.location.origin + '/',
  clientId: 'backoffice',
  showDebugInformation: true,
} as AuthConfig;

export const environment = {
  name: 'Prod',
  title: '스프린트 매니저',
  production: true,
  apiBaseUrl: {
    web: 'https://api.sprintapp.team',
    ios: 'capacitor://localhost',
    android: 'http://localhost',
  },
  authConfig: {
    web: webAuthConfig,
  },
  authAllowedUrls: {
    web: ['https://app.sprintapp.team/api', 'https://api.sprintapp.team'],
  },
  s3Path: 'https://static.sprintapp.team',
  channelPluginKey: 'e43dc155-7cd9-4b31-ae22-105c0593d857',
  imageResizeUrl: 'https://image-resize.sprintapp.team',
};
